import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Scrolls to top on route change (but preserves in-page anchor scrolls when
 * a hash is present, e.g. /host-a-machine#form).
 */
export default function ScrollToTop() {
    const { pathname, hash } = useLocation();
    useEffect(() => {
        if (hash) {
            // let the browser resolve the hash naturally
            const el = document.getElementById(hash.replace("#", ""));
            if (el) {
                el.scrollIntoView({ behavior: "smooth", block: "start" });
                return;
            }
        }
        window.scrollTo({ top: 0, behavior: "instant" in window ? "instant" : "auto" });
    }, [pathname, hash]);
    return null;
}
